import { FCWithChildren } from '@types';
import React from 'react';
import useLayoutContext from '@hooks/useLayoutContext';
import PskBody from './PskBody';
import OtherBody from './OtherBody';
import { Button } from '@components';

type WifiEnabledInstructionsProps = {
  preWiredKey?: string;
};

const WifiEnabledInstructions: FCWithChildren<WifiEnabledInstructionsProps> = ({ preWiredKey }) => {
  const { isCaptivePortal, pskEnabled, loginToCaptivePortal } = useLayoutContext();
  return (
    <>
      {isCaptivePortal && (
        <div>
          <h1 className="text-3xl">Account Created</h1>
          <div className="border-t-[#FAA83A] border-t my-3" />
        </div>
      )}
      <div className="mb-2">
        <h3 className="text-2xl">GET CONNECTED!</h3>
      </div>
      {pskEnabled ? <PskBody preWiredKey={preWiredKey} /> : <OtherBody preWiredKey={preWiredKey} />}
      {isCaptivePortal && (
        <div>
          <div className="text-4xl font-black text-center border-t-[#FAA83A] border-t mt-10 mb-6 pt-4">
            OR
          </div>
          <Button
            type="button"
            layout="primary"
            size="large"
            block
            onClick={() => {
              loginToCaptivePortal();
            }}
          >
            Connect With Limited Access
          </Button>
        </div>
      )}
    </>
  );
};

export default WifiEnabledInstructions;
